/*
 *  interface to the Figma plugin controller
 */

const figma = {
    // method call to the figma plugin controller
    call: (method, args) => {
        // console.log('calling figma', method, args);
        // parent.postMessage({ pluginMessage: { type: 'call', method, args } }, '*');
    },
    // callbacks are handled inside the lesson-context directly now
};

export default figma;
